import { useState } from "react";
import { Input } from "semantic-ui-react";
import Calendar from "react-calendar";
import "./CalendarInput.css";
import { CSSTransition } from "react-transition-group";

interface IProps {
    timestampDate: string | null;
    handleTimestampDateChange: (e: any) => void;
    primary:string;
}

export const CalendarInput = ({ timestampDate, handleTimestampDateChange, primary }: IProps) => {
    const [showCalendar, setShowCalendar] = useState(false);

    return (
        <Input
            id={`input-calendar-input-a-${primary}`}
            tabIndex={0}
            className="calendar-input"
            onBlur={(e: any) => {
                if (e.relatedTarget === null) setShowCalendar(false);
            }}
        >
            <input
                id={`input-calendar-open-a-${primary}`}
                readOnly
                value={timestampDate ? timestampDate : ""}
                className={`date-input ${showCalendar ? "calendar-open" : ""}`}
                onClick={() => setShowCalendar(!showCalendar)}
            />
            <CSSTransition
                id={`showCalendar-calendarInput-${primary}`}
                in={showCalendar}
                timeout={300}
                classNames="show-calendar"
                unmountOnExit
                onEnter={() => setShowCalendar(true)}
                onExited={() => setShowCalendar(false)}
            >
                <Calendar
                    className="portal-calendar"
                    onChange={(e: any) => {
                        handleTimestampDateChange(e);
                        setShowCalendar(false);
                    }}
                />
            </CSSTransition>
        </Input>
    );
};
